/* eslint-disable @typescript-eslint/no-extra-semi */
import React, { useContext } from 'react'
import { IdentityCard } from '@cb/apricot-react-identity-card'
import { CardBand } from '@cb/apricot-react-band'
import { ConfigContext } from '../../AppProvider'

const appId = 398

const Login: React.FC = () => {
  const config = useContext(ConfigContext)

  const bodyText = (
    <div>
      <p
        className="app-update-msg"
        style={{ color: '#fedb00', fontSize: '18px', fontWeight: 'bold' }}
      >
        {config.announcement || ''}
      </p>
      <p style={{ fontSize: '18px' }}>
        Consistent high school and neighborhood information for colleges. Public information on
        Landscape can be found in{' '}
        <a className="cb-white-color" href="https://www.collegeboard.org/landscape">
          www.collegeboard.org/landscape
        </a>
      </p>
    </div>
  )

  return (
    <CardBand
      heading="RECRUITMENT AND ADMISSIONS MANAGEMENT"
      title="Landscape"
      description={bodyText}
      className="cb-blue5-bg cb-white-color"
      tintClass="cb-tint-blue5-1"
    >
      {!config.disableLogin && (
        <IdentityCard
          className="cb-black1-color"
          id="identityCardComponent"
          appId={appId}
          destinationUrl={window.location.href}
          loginUrl="https://account.collegeboard.org/login/login"
          createAccountUrl="https://account.collegeboard.org/login/signUp"
          isStudent={false}
        />
      )}
    </CardBand>
  )
}

export { Login }
